import create from "zustand";
import { persist } from "zustand/middleware";
import { parseTrainingParams } from "@/utils/academyMFEUtils";

/**
 * LocalStorage key for the Academy microfrontend context store.
 * This key is used to persist training parameters (courseId, courseVersion)
 * across page refreshes and login sessions, ensuring the Academy drawer
 * can auto-open with the correct training context after authentication.
 */
export const ACADEMY_STORE_KEY = "academy-store";

export interface TrainingParams {
	initialTrainingId: string;
	initialTrainingVersion: string;
}

// This store is used to provide context to microfrontends from the host application.
export const useAcademyMFEContextStore = create(
	persist(
		(set) => ({
			trainingParams: null as TrainingParams | null,

			setTrainingParams: (params: TrainingParams) => {
				set({ trainingParams: params });
			},

			clearTrainingParams: () => {
				set({ trainingParams: null });
			},

			parseAndSetTrainingParams: (url: string) => {
				const queryString = url.split("?")[1] || "";
				const parsedParams = parseTrainingParams(queryString);

				if (parsedParams.trainingId && parsedParams.trainingVersion) {
					const params = {
						initialTrainingId: parsedParams.trainingId,
						initialTrainingVersion: parsedParams.trainingVersion,
					};
					set({ trainingParams: params });
				}
			},
		}),
		{
			name: ACADEMY_STORE_KEY,
			getStorage: () => localStorage,
		}
	)
);
